import React, { useEffect, useState } from "react";
import { NavLink } from 'react-router-dom';
import "bootstrap/dist/css/bootstrap.min.css";
import './NewArrivals.css';
import { useNavigate } from "react-router-dom";

const NewArrivals = () => {
    const [country, setCountry] = useState('Loading...');
    const [cars, setCars] = useState([]);
    const navigate = useNavigate();

    useEffect(() => {
        // Fetch car details
        fetch(`https://skcapi.btcjapan.co/get-car-details.php`)
            .then(response => {
                if (!response.ok) {
                    throw new Error(`HTTP error! Status: ${response.status}`);
                }
                return response.json();
            })
            .then(data => {
                //console.log("Fetched car data:", data);
                setCars(data);
            })
            .catch(error => {
                console.error("Error fetching car details:", error);
            });
    }, []);

    const handleCarClick = (carId) => {
        navigate(`/vehicle-details/${carId}`);
    };

    return (
        <section>
            <div className="container-car my-4">
                <div className="main-title">
                    <h2>New Arrival</h2>
                    <hr className="title-line" />
                </div>

                <div className="row g-3">
                    {cars.map((car) => (
                        <div className="col-6 col-sm-6 col-md-4 col-xl-3 col-xxl-2" key={car.id}>
                            <NavLink to={`/vehicle-details/${car.id}`} className="text-decoration-none text-dark">
                                <div className="car-card position-relative">
                                    <img
                                        src={`https://skcapi.btcjapan.co/${car.images}`}
                                        alt={car.model}
                                        style={{ cursor: 'pointer' }}
                                        className="img-fluid"
                                    />
                                    <div className="car-details">
                                        <p className="car-title">{car.maker} {car.model}</p>
                                        <p>{car.mileage} Km<br />{car.fuel} | {car.year}</p>
                                        <div className="car-price">
                                            <div className="price-row">
                                                <div className="price-label">Price:</div>
                                                <div className="price-value">
                                                    <span>${car.price}</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </NavLink>
                        </div>
                    ))}
                </div>

                <div className="show-more text-end">
                    <NavLink to="/inventory" className="nav-link"><button>Show More</button></NavLink>
                </div>
            </div>
        </section>
    );
};

export default NewArrivals;